<template>
  <div class="d-flex align-items-center">
    <van-col class="color-88 font-10 pl-2 d-flex align-items-center cursor-pointer"
             @click="updateLike(true)">
      <van-icon v-if="isLike" class="mr-1" name="good-job" color="#2474ff" size="21"/>
      <van-icon v-else class="mr-1" name="good-job-o" size="21"/>
      {{likeObj.likeTopic?likeObj.likeTopic.likeCount:0}}
    </van-col>
    <van-col class="color-88 font-10 pl-2 d-flex align-items-center cursor-pointer"
             @click="updateLike(false)">
      <img v-if="disLike" class="icon-reply ml-3 mr-1" src="/static/img/icon/cai-o.png">
      <img v-else class="icon-reply ml-3 mr-1" src="/static/img/icon/cai.png">
      {{likeObj.likeTopic?likeObj.likeTopic.dislikeCount:0}}
    </van-col>
  </div>
</template>

<script>

  import Vue from 'vue';
  import {
    Icon,
    Col,
  } from 'vant';

  Vue.use(Col);
  Vue.use(Icon);
  export default {
    name: "dislikeComponent",
    data() {
      return {
        likeMap: {},
        likeObj: {},
        isLike: false,
        disLike: false,
      }
    },
    props: [
      'item',
    ],
    created() {
      if (this.item) {
        this.likeObj = this.item;
        if (this.likeObj.likeTopic) {
          if (this.likeObj.likeTopic.currentUserLike) {
            this.isLike = true;
            this.disLike = false;
          } else {
            if (this.likeObj.likeTopic.currentUserLike === false) {
              this.disLike = true;
            } else {
              this.disLike = false;
            }
            this.isLike = false;
          }

        } else {
          this.isLike = false;
          this.disLike = false;
        }
      }
    },
    mounted() {

    },
    watch: {
      item: function (newVal, oldVal) {
        if (newVal) {
          this.likeObj = newVal;
          if (this.likeObj.likeTopic) {
            if (this.likeObj.likeTopic.currentUserLike) {
              this.isLike = true;
              this.disLike = false;
            } else {
              if (this.likeObj.likeTopic.currentUserLike === false) {
                this.disLike = true;
              } else {
                this.disLike = false;
              }
              this.isLike = false;
            }
          } else {
            this.isLike = false;
            this.disLike = false;
          }
        }
      }
    },
    methods: {
      updateLike(status) {
        let model = {};
        model.mainId = this.likeObj.id;
        model.mainType = 'comment';
        model.mainUserId = this.likeObj.commenter;
        model.rootId = this.likeObj.mainId;
        model.rootType = this.likeObj.mainType;
        model.like = status; //标记是赞/踩

        if ((!this.isLike && status) || (!this.disLike && !status)) {
          this.addLike(model);
        } else if ((this.isLike && status) || (this.disLike && !status)) {
          this.cancelLike(model);
        }
      },
      //点赞
      addLike(model) {
        if(!this.likeObj.likeTopic) {
          this.likeObj.likeTopic = {likeCount: 0, dislikeCount: 0};
        }
        this.$store.dispatch('addLike', {model: model}).then((res) => {
          //赞成功
          if (model.like) {
            this.$toast('点赞成功')
            this.isLike = true;
            this.likeObj.likeTopic.likeCount++;
            if (this.disLike) {
              this.disLike = false;
              if (this.likeObj.likeTopic.dislikeCount > 0) {
                this.likeObj.likeTopic.dislikeCount--
              } else {
                this.likeObj.likeTopic.dislikeCount = 0;
              }
            }
          } else {
            this.$toast('踩成功了')
            //踩成功
            this.disLike = true;
            this.likeObj.likeTopic.dislikeCount++;
            if (this.isLike) {
              this.isLike = false;
              if (this.likeObj.likeTopic.likeCount > 0) {
                this.likeObj.likeTopic.likeCount--
              } else {
                this.likeObj.likeTopic.likeCount = 0;
              }
            }
          }

        }).catch(err => {
          if (err && err.response && err.response.data && err.response.data.consumerMessage) {
            this.$toast(err.response.data.consumerMessage);
          } else {
            this.$toast('操作失败');
          }
        })
      },
      //取消点赞
      cancelLike(model) {
        this.$store.dispatch('cancelLike', {model: model}).then((res) => {
          //取消赞成功
          if (model.like) {
            this.isLike = false;
            this.likeObj.likeTopic.likeCount--;

          } else {
            //取消踩成功
            this.disLike = false;
            this.likeObj.likeTopic.dislikeCount--;
          }

        }).catch(err => {
          if (err && err.response && err.response.data && err.response.data.consumerMessage) {
            this.$toast(err.response.data.consumerMessage);
          } else {
            this.$toast('操作失败');
          }
        })
      },

    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }


</style>
